import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-line text-base"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link>
              <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-100 transition-colors">漫画分类</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-400">
                <i className="ri-mail-line mr-2"></i>{siteInfo.email}
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-customer-service-line mr-2"></i>在线客服：工作日 9:00-18:00
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {siteInfo.year} {siteInfo.name} 版权所有 | 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}